<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><b><i>Part One</i></b></div>
<div class="ctag1">‘Rich with the spoils of time . . .’ <br/>Thomas Gray <br/><i>Elegy Written in a Country Churchyard</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590208007_oeb_p01_r1.vue?0f81df6c